import styled from 'styled-components';

import { COLORS } from 'styles/style-constants';

import { Bar } from '../ContentPlaceholder/ContentPlaceholder.styled';

export const Group = styled.div`
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    width: max-content;
    isolation: isolate;
`;

export const Logo = styled(Bar)<{ $large: boolean }>`
    box-sizing: content-box;

    &:first-child {
        border: ${({ $large }) => ($large ? '0.5rem' : '0.3rem')} solid ${COLORS.surface};
        z-index: 1;
    }

    &:not(:first-child) {
        margin-left: ${({ $large }) => ($large ? '-3rem' : '-1rem')};
    }
`;
